import packageInfo from '../../package.json';

export const environment = {
  production: false,
  hmr: false,
  version: packageInfo.version + '-dev',
  envName: 'DEV',
  environmentName: 'DEV',
  origins: ['https://aip-base-ui-dev.archinsurance.io'],
  aipHostPort: 'http://aigi-drvjbss001:8080/',
  aipHostPort1: 'https://aip-base-api-dev.archinsurance.io/aip-base-api/aip-base-api',
  aipHostPort2: 'https://aip-authorization-ms-dev.archinsurance.io',
  aipRedirectUrl: 'http://aigi-drvjbss001.corp.archcapservices.com:8080/archweb',
  aipAdminRedirectUrl: 'https://aip-admin-ui-dev.archinsurance.io',
  aipUserProfileRedirectUrl: 'https://stgmy.archinsurance.com',
  oldplportalurl: 'http://aigi-drvjbss001:8080/daspl4',
  quickClaimsUrl: 'http://aigi-drvjbss001:8080/claimsWeb/#/claimIncident',
  aipHostPortAdmin: 'https://aip-admin-api-dev.archinsurance.io',
  appUrl: 'https://aip-base-ui-dev.archinsurance.io/',
  AUTH_URL: 'https://archinsurance-dev.auth0.com/oauth/token',

  //ENV specific variables
  internalUserFlag: true,
  externalUserFlag: true,
  showDebug: true,
  SKIP_ENV_ROLE_CHECK: true,
};
